import { monitor_vehicleService } from '../_services';

const state = { onRequest: false, monitor_vehicle: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        monitor_vehicleService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  monitor_vehicle: state => {
    return state.monitor_vehicle
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.monitor_vehicle = [];
    },
    success(state) {
      state.onRequest = false;
    },
    clear_data(state) {
      state.onRequest = false;
      state.monitor_vehicle = [];
    },
    success_data(state, data) {
      state.onRequest = false;
      state.monitor_vehicle = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const monitor_vehicles = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
